<template>
  <div class="card edit">
    <div class="card-body">
      <div class="d-flex align-items-center justify-content-between">
        <h5>Groepen bewerken</h5>
        <div>
          <a class="btn btn-outline-primary btn-sm me-1"
             @click="newItem">Nieuwe groep
            <font-awesome-icon icon="plus-circle" />
          </a>
          <a class="btn btn-outline-primary btn-sm"
             @click="$parent.detailEdit = ''">Sluiten
            <font-awesome-icon icon="window-close" />
          </a>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <div v-if="mode !== ''"
               class="card mb-3">
            <div class="card-body">
              <div v-if="composed || mode === 'new'"
                   class="form-check mb-2">
                <input class="form-check-input"
                       type="checkbox"
                       :disabled="mode === 'edit'"
                       id="composedGroup"
                       @change="checkComposedGroup"
                       v-model="composed" />
                <label class="form-check-label"
                       for="composedGroup"> Samengestelde groep </label>
              </div>
              <div class="form-floating mb-2">
                <input type="text"
                       class="form-control"
                       id="name"
                       v-model="group.naam"
                       :class="{ 'is-invalid': $v.group.naam.$error }" />
                <label for="name">Naam</label>
              </div>
              <small class="error mb-2"
                     v-if="!isUniqueGroupName">Deze groepsnaam is al in gebruik. Kies een andere.</small>
              <div v-if="!composed"
                   class="form-group mb-2">
                <label>Jaargroep</label>
                <multiselect v-model="group.jaargroep"
                             placeholder="Kies een Jaargroep"
                             :class="{ 'is-invalid': $v.group.jaargroep.$error }"
                             label="naam"
                             track-by="key"
                             :hideSelected="true"
                             :selectLabel="'Selecteren'"
                             :deselectLabel="'Verwijderen'"
                             :selectedLabel="'Geselecteerd'"
                             :options="yearGroupOptions"
                             :multiple="false"></multiselect>
              </div>
              <div class="form-floating mb-2">
                <textarea class="form-control"
                          v-model="group.omschrijving"
                          id="remarks"></textarea>
                <label for="remarks">Omschrijving</label>
              </div>
              <a class="btn btn-outline-primary btn-sm me-1"
                 @click="cancelItem">Cancel
                <font-awesome-icon icon="window-close" />
              </a>
              <a class="btn btn-secondary btn-sm"
                 @click="saveItem">{{ mode === "new" ? "Groep opslaan" : "Groep wijzigen" }}
                <font-awesome-icon icon="save" />
              </a>
            </div>
          </div>
          <!-- OVERVIEW -->
          <div class="accordion"
               id="overview-accordion">
            <div class="accordion-item">
              <h2 class="accordion-header"
                  id="overview">
                <button class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#overview-list"
                        aria-expanded="true"
                        aria-controls="overview-list">Overzicht Groepen</button>
              </h2>
              <div id="overview-list"
                   class="accordion-collapse collapse show"
                   aria-labelledby="overview"
                   data-bs-parent="#overview">
                <div class="accordion-body">
                  <h5 class="mt-3">Groepen</h5>
                  <ul class="list-group">
                    <li v-for="(groep, index) in content.groepen.groep"
                        :key="groep.naam"
                        class="list-group-item d-flex align-items-center justify-content-between">
                      {{ groep.naam }}
                      <span>
                        <button :disabled="disableButtons"
                                class="btn btn-outline-primary btn-sm me-2"
                                @click="editItem(index)">
                          Bewerk
                          <font-awesome-icon icon="edit" />
                        </button>
                        <button :disabled="disableButtons"
                                class="btn btn-outline-primary btn-sm"
                                @click="deleteItem(index)">
                          Verwijder
                          <font-awesome-icon icon="trash-alt" />
                        </button>
                      </span>
                    </li>
                  </ul>
                  <h5 v-if="content.groepen.samengestelde_groep && content.groepen.samengestelde_groep.length"
                      class="mt-3">Samengestelde groepen</h5>
                  <ul class="list-group">
                    <li v-for="(samengesteldeGroep, index) in content.groepen.samengestelde_groep"
                        :key="samengesteldeGroep.naam"
                        class="list-group-item d-flex align-items-center justify-content-between">
                      {{ samengesteldeGroep.naam }}
                      <span>
                        <button :disabled="disableButtons"
                                class="btn btn-outline-primary btn-sm me-2"
                                @click="editItem(index, true)">
                          Bewerk
                          <font-awesome-icon icon="edit" />
                        </button>
                        <button :disabled="disableButtons"
                                class="btn btn-outline-primary btn-sm"
                                @click="deleteItem(index, true)">
                          Verwijder
                          <font-awesome-icon icon="trash-alt" />
                        </button>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import getUniqueKey from "@/helpers/getUniqueKey";
import { yearGroupOptions } from "@/constants/yearGroupOptions";

const getInitGroup = () => {
  return { key: { key: "" } };
};

export default {
  name: "groupEdit",
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      group: getInitGroup(),
      mode: "",
      composed: false,
      currentEditedGroupName: "",
      isUniqueGroupName: true,
      yearGroupOptions: yearGroupOptions,
      disableButtons: false,
    };
  },
  validations: {
    group: {
      naam: {
        required,
      },
      jaargroep: {
        required: requiredIf(function () {
          return !this.composed
        }),
      },
    },
  },
  methods: {
    checkGroupName(name) {
      let groupsDoesnotContainName = true;
      this.content.groepen.groep.forEach((group) => {
        if (group.naam === name) groupsDoesnotContainName = false;
        if (group.naam === name && this.mode === "edit" && this.currentEditedGroupName === group.naam) groupsDoesnotContainName = true;
      });
      if (this.content.groepen.samengestelde_groep) {
        this.content.groepen.samengestelde_groep.forEach((group) => {
          if (group.naam === name) groupsDoesnotContainName = false;
        });
      }
      return groupsDoesnotContainName;
    },
    async saveItem() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.isUniqueGroupName = await this.checkGroupName(this.group.naam);
      if (!this.isUniqueGroupName) {
        return;
      }

      if (this.mode === "new") {
        this.group.key.key = getUniqueKey();
        if (!this.composed) {
          this.content.groepen.groep.push(this.group);
        } else {
          this.content.groepen.samengestelde_groep.push(this.group);
        }
        this.$toast.success("Groep toegevoegd");
        this.mode = "";
        this.disableButtons = false;
      } else {
        if (!this.composed) {
          let originalGroups = [...this.content.groepen.groep];
          let getGroupId = originalGroups.findIndex((element) => element.key.key === this.group.key.key);
          originalGroups[getGroupId] = { ...originalGroups[getGroupId], ...this.group };
          this.content.groepen.groep = originalGroups;
          this.$toast.success("Groep gewijzigd");
        } else {
          let originalComposedGroups = [...this.content.groepen.samengestelde_groep];
          let getComposedGroupId = originalComposedGroups.findIndex((element) => element.key.key === this.group.key.key);
          originalComposedGroups[getComposedGroupId] = { ...originalComposedGroups[getComposedGroupId], ...this.group };
          this.content.groepen.samengestelde_groep = originalComposedGroups;
          this.$toast.success("Samengestelde groep gewijzigd");
        }

        this.mode = "";
        this.$v.$reset();
        this.group = getInitGroup();
        this.currentEditedGroupName = "";
        this.isUniqueGroupName = true;
        this.disableButtons = false;
      }
    },
    newItem() {
      this.disableButtons = true;
      this.mode = "new";
      this.$v.$reset();
      this.composed = false;
      this.group = getInitGroup();
      this.currentEditedGroupName = "";
      this.isUniqueGroupName = true;
    },
    editItem(i, composed) {
      this.disableButtons = true;
      if (!composed) {
        this.composed = false;
        this.group = { ...this.content.groepen.groep[i] };
      } else {
        this.composed = true;
        this.group = { ...this.content.groepen.samengestelde_groep[i] };
      }
      this.mode = "edit";
      this.currentEditedGroupName = this.group.naam;
      window.scrollTo(0, 0);
    },
    deleteItem(i, composed) {
      if (!composed) {
        this.$delete(this.content.groepen.groep, i);
      } else {
        this.$delete(this.content.groepen.samengestelde_groep, i);
      }
      this.$toast.success("Groep verwijderd");
    },
    cancelItem() {
      this.mode = "";
      this.disableButtons = false;
      this.$v.$reset();
      this.group = getInitGroup();
      this.currentEditedGroupName = "";
      this.isUniqueGroupName = true;
    },
    checkComposedGroup() {
      // remove yearGroup if exists
      if (this.composed) {
        delete this.group.jaargroep;
      }
    },
  },
};
</script>
